import { useDeviceType } from '../../../hooks/useDeviceType';
import { Logo } from './Logo';

export function LogoList({
  logos,
  title,
  subTitle,
  handleAddNewLogo,
  activeLogoIndex,
  handleActiveLogoIndex,
}) {
  const device = useDeviceType();

  return (
    <div
      style={{
        boxSizing: 'border-box',
        display: 'flex',
        gap: '12px',
        scrollbarWidth: 'none',
        overflowX: device === 'mobile' ? 'auto' : 'hidden',
        overflowY: device === 'mobile' ? 'hidden' : 'auto',
        flexDirection: device === 'mobile' ? 'row' : 'column',
        height: '100%',
      }}
    >
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <div className="addLogo">
          <img src="/theme/img/plusIcon.svg" alt="plusIcon" />
          <input
            className="fullOwner_opacity"
            type="file"
            name="myfile"
            accept="image/*"
            style={{ width: '100%', height: '100%' }}
            onChange={(e) => handleAddNewLogo(e)}
          />
        </div>
      </div>

      {logos?.map((model, index) => {
        const isNew = model.Position === null;

        return (
          <Logo
            key={model?.Id || index}
            scale={model.Scale}
            rotate={model.Rotate}
            image={model.Thumbnail}
            onClick={(ratio) => handleActiveLogoIndex(index, ratio)}
            active={activeLogoIndex === index}
            isNew={isNew}
            title={title}
            subTitle={subTitle}
          />
        );
      })}
    </div>
  );
}
